import axios from 'axios'

const Axios = axios

Axios.defaults.headers.common = {
	'X-WP-Nonce': window.wpApiSettings ? window.wpApiSettings.nonce : false,
	'X-Requested-With': 'XMLHttpRequest'
}
Axios.defaults.baseURL = window.wpApiSettings ? window.wpApiSettings.root : false

export default Axios



// WEBPACK FOOTER //
// ./src/admin/assets/js/app/utils/axios-setup.js